module.exports = "<span class='tag' [class.selected]=\"isSelected\" [class.excluded]=\"isExcluded\" (click)='switch($event)'>\n  {{label}}\n</span>\n\n<span *ngIf='showSubtags'>\n  <span *ngFor='let tpl of subtags'>\n    <span class='subtag' [class.selected]=\"isSubtagSelected(tpl[0])\" (click)='switchSubtag(tpl[0],$event)' [class.excluded]=\"isSubtagExcluded(tpl[0])\">\n      {{tpl[1]}}\n    </span>\n  </span>\n\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/rating-tag-filter/rating-tag-filter.component.html
// module id = ../../../../../src/app/rating-tag-filter/rating-tag-filter.component.html
// module chunks = main